import { LifeBuoy, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Barra fina no topo (sticky) exibida enquanto o Super Admin estiver em Modo Suporte
// (impersonando uma empresa). Botão "Encerrar Acesso" retorna à conta original.
export function SupportBanner() {
  const { user, endImpersonate } = useAuth();
  if (!user?._impersonating) return null;
  const empresaNome = user._impersonate_empresa_nome || "empresa";
  const handleEnd = async () => {
    try {
      await endImpersonate();
      toast.success("Acesso de suporte encerrado");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao encerrar acesso");
    }
  };
  return (
    <div
      data-testid="support-banner"
      className="sticky top-0 z-50 w-full bg-amber-500 text-white shadow-md"
    >
      <div className="max-w-full flex items-center justify-between gap-3 px-4 py-1.5 text-sm font-medium">
        <div className="flex items-center gap-2 min-w-0">
          <LifeBuoy className="w-4 h-4 shrink-0" />
          <span className="truncate">
            Acesso de Suporte: <b>{empresaNome}</b>
          </span>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={handleEnd}
          data-testid="btn-end-impersonate"
          className="h-7 text-white hover:bg-amber-600 hover:text-white gap-1"
        >
          <X className="w-3.5 h-3.5" />
          Encerrar Acesso
        </Button>
      </div>
    </div>
  );
}
